import { SpaceInfo } from './space-info.model';
import {
  AssetDepartmentCount,
  AssetInfo,
  DocumentDto,
  Occupancy
} from './asset-details.model';
import { TicketDetails } from './ticket-details.model';
export interface SpaceDetails extends SpaceInfo {
  assets: Array<AssetInfo>;
  tickets: Array<TicketDetails>;
  documents: Array<DocumentDto>;
  assetDepartmentCount: AssetDepartmentCount;
  occupancy: Array<Occupancy>;
}
